/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Media.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-media");
exports.Media = function Media(_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, _b = _a.padded, padded = _b === void 0 ? true : _b, props = tslib_1.__rest(_a, ["children", "className", "onClick", "padded"]);
    var TagName = !!onClick ? "button" : "div";
    var elementProps = tslib_1.__assign({ className: classnames(moduleClassName(), className, padded && moduleClassName("isPadded")), type: !!onClick ? "button" : undefined, onClick: onClick }, props);
    return React.createElement(TagName, tslib_1.__assign({}, elementProps), children);
};
exports.Media.propTypes = {
    onClick: PropTypes.func,
    padded: PropTypes.bool
};
exports.Media.defaultProps = {
    padded: true
};
exports.MediaVisual = function MediaVisual(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("visual"), className) }, children));
};
exports.MediaContent = function MediaContent(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("content"), className) }, children));
};
exports.MediaAside = function MediaAside(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("aside"), className) }, children));
};
var MediaIcon = function MediaIcon(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("icon"), className) }, children));
};
var MediaIconButton = function MediaIconButton(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName("iconButton"), className) }, children));
};